import { render, staticRenderFns } from "./AddGroupChat.vue?vue&type=template&id=2fa469da&"
import script from "./AddGroupChat.vue?vue&type=script&lang=js&"
export * from "./AddGroupChat.vue?vue&type=script&lang=js&"
import style0 from "./AddGroupChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports